import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DealLabel } from '@ori/presentation-components';
import { shouldForwardProp } from '@ori/presentation-utils';
import { styled } from '@ori-ui/mui';
export var PointsAndLabelsWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  top: 0,
  width: '100%'
});
export var Points = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(function (_ref) {
  var theme = _ref.theme,
    hasEnoughPoints = _ref.hasEnoughPoints;
  return _objectSpread(_defineProperty({
    alignItems: 'center',
    background: theme.palette.grey[200],
    borderRadius: '50%',
    color: theme.palette.common.white,
    display: 'flex',
    fontSize: 18,
    fontWeight: theme.typography.fontWeightBold,
    height: 45,
    justifyContent: 'center',
    left: 10,
    position: 'absolute',
    top: 10,
    width: 45,
    zIndex: 1
  }, theme.breakpoints.down(1024), {
    fontSize: 14,
    height: 35,
    width: 35
  }), hasEnoughPoints && {
    background: theme.palette.offer.dark
  });
});
export var Deal = styled(DealLabel)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    margin: theme.spacing(3, 3, 0, 3)
  };
});
//# sourceMappingURL=styles.js.map